import $ from 'jquery';
import Tips from '../Tips';
import NavigationCart from './NavigationCart';
/* ===============================================================
  WoocommerceSingleProduct
=============================================================== */
class WoocommerceSingleProduct {
    constructor() {
        // Only run in single product page
        if ($('.irantheme-single-product').length) {
            this.tip = new Tips();
            this.navigationCart = new NavigationCart();
            this.events();
        }
    }

    events() {
        let current = this;

        $(window).on('load', () => {
            // Enable product summary sticky mode
            this.productSummaryFixed();
        });
        $(window).on('scroll', () => {
            // Enable product summary sticky mode
            this.productSummaryFixed();
        });
        $(window).on('resize', () => {
            // Enable product summary sticky mode
            this.productSummaryFixed();
        });
        // Add ajax operation to Add to card button
        this.AddToCardBtnAjax();
        this.handleExternalProductRedirect();
        // Init plus & minus button for first load
        this.initAddToCardQuantityBtn();
        // Increase & decrease quantity of products
        this.addToCardQuantity();
        // Switch variation Clickable
        this.switchCustomVariationDefaultValueInit();
        // Switch variation Clickable
        this.switchCustomVariationClickable();
        // Color switch variation label
        this.colorSwitchVariationLabel();
        // Add selected color class to tabs active mode
        this.woocommerceTabPanelInit();
        // Add hover color class to a tag in breadcrumb
        this.colorBreadcrumbInit();
        // Product permalink copy to clipboard
        this.InitProductShareModal();
        // Disable custom switches when parent select option is disabled
        this.switchCustomDisabler();
        // Show current variable price in shopping summary col
        this.initShoppingSummaryProductDetails();
        // Simulate and sync add to cart button click
        this.syncSidebarAndMainButtons();
        this.syncNavbarMobileAndMainButtons();
        this.syncAllQuantityBtn();
        // Init single product popup modal
        this.initProductQuestionReplyModal();
        this.initProductQuestionSubmissionModal();
        this.initProductAddCommentModal();
        // Init downloadable file details
        this.initDownloadableFileDetails();
        // Init review and Q&A quick view
        this.initReviewAndQAQuickView();
    }

    productSummaryFixed() {
        if ($(document).width() < 991.98) {
            return;
        }
        // Throttling utility to limit function execution rate (e.g., 60 times per second)
        function throttle(func, limit) {
            let inThrottle;
            return function () {
                const args = arguments;
                const context = this;
                if (!inThrottle) {
                    func.apply(context, args);
                    inThrottle = true;
                    // Set timeout for next execution (e.g., 16ms for ~60fps)
                    setTimeout(() => (inThrottle = false), limit);
                }
            };
        }

        let $stickyBox = $(
            '.irantheme-single-product-content-shopping-summary-wrapper',
        );
        let $parentCol = $stickyBox.closest(
            '.irantheme-single-product-content-shopping-summary',
        );
        let $fileDetailsBox = $(
            '.irantheme-single-product-content-shopping-summary-file-wrapper',
        );
        let $fileTipBox = $(
            '.irantheme-single-product-content-shopping-summary-file-tip-wrapper',
        );

        if (!$stickyBox.length || !$parentCol.length) {
            return;
        }

        const $adminBar = $('#wpadminbar');
        const desiredOffset = 30; // Your desired top offset (30px)

        // Variables for calculations, initialized in calculateBounds()
        let adminBarHeight = 0;
        let stickyOffset = 0;

        // --- Utility Functions ---

        // Calculate Admin Bar height and final offset
        function calculateBounds() {
            // Check for WordPress Admin Bar height
            adminBarHeight = $adminBar.length ? $adminBar.outerHeight(true) : 0;

            // Final offset: Desired + Admin Bar
            stickyOffset = desiredOffset + adminBarHeight;
        }

        // Explicitly set the width of the sticky box based on its parent column
        function setStickyWidth() {
            const parentWidth = $parentCol.width();
            $stickyBox.css('width', parentWidth + 'px');
        }

        // Reset styles for the normal (static) state
        function resetStyles() {
            $stickyBox.removeClass('irantheme-is-sticky');
            $stickyBox.removeClass('irantheme-is-stuck');
            $stickyBox.css('top', '');
            $stickyBox.css('width', '');
        }

        // --- Main Scroll Handler ---

        function handleStickyScroll() {
            // Recalculate positions in every scroll to handle dynamic content
            let stickyStart = '';
            if ($fileTipBox.length) {
                stickyStart =
                    $fileTipBox.offset().top + $fileTipBox.outerHeight(true);
            } else if ($fileDetailsBox.length) {
                stickyStart =
                    $fileDetailsBox.offset().top +
                    $fileDetailsBox.outerHeight(true);
            } else {
                stickyStart = $parentCol.offset().top;
            }
            const stickyHeight = $stickyBox.outerHeight(true);
            const parentColHeight = $parentCol.outerHeight(true);

            let panelWrapperHeight = $(
                '.irantheme-single-product-content-tabs-panel:visible',
            ).outerHeight(true);
            const limitPoint =
                $parentCol.offset().top + parentColHeight - stickyHeight;

            const scrollTop = $(window).scrollTop();

            // CRITICAL FIX: Skip stickiness if the box is taller than its parent column

            if (stickyHeight >= panelWrapperHeight - 100) {
                resetStyles();
                return;
            }

            // Ensure width is set correctly before changing position
            setStickyWidth();

            // 1. Check if scroll position is past the sticky start point
            if (scrollTop > stickyStart - stickyOffset) {
                // 2. Check if we are still above the bottom limit point
                if (scrollTop < limitPoint - adminBarHeight - desiredOffset) {
                    // State: STICKY (Fixed)
                    $stickyBox.addClass('irantheme-is-sticky');
                    $stickyBox.removeClass('irantheme-is-stuck');

                    // Set top dynamically (40px + Admin Bar)
                    $stickyBox.css('top', stickyOffset + 'px');
                } else {
                    // State: STUCK (Absolute to Parent Bottom)
                    $stickyBox.removeClass('irantheme-is-sticky');
                    $stickyBox.addClass('irantheme-is-stuck');

                    // Clear top in absolute state
                    $stickyBox.css('top', '');
                }
            } else {
                // State: NORMAL (Static)
                resetStyles();
            }
        }

        // --- Execution and Events ---

        // Initial setup
        calculateBounds();
        handleStickyScroll();

        // Attach scroll handler with throttling for performance
        $(window).on('scroll', function () {
            throttle(handleStickyScroll, 16);
        });

        // Recalculate everything on window resize
        $(window).on('resize', function () {
            calculateBounds();
            handleStickyScroll();
        });
    }

    AddToCardBtnAjax() {
        let current = this;
        $(document).on('submit', 'form.cart', function (e) {
            if (!$(this).hasClass('irantheme-add-to-cart-ajax-disabled')) {
                e.preventDefault();
                let addToCardBtn = $(this).find(
                    '.irantheme-single-add-to-cart-button',
                );
                let sidebarBtn = $(
                    '.irantheme-single-product-shopping-summary .product-add-to-card-button .single_add_to_cart_button',
                );
                var form = $(this),
                    mainId = form.find('.single_add_to_cart_button').val(),
                    fData = form.serializeArray();

                form.block({
                    message: null,
                    overlayCSS: {
                        background: '#fff',
                        opacity: 0.6,
                    },
                });

                if (mainId === '') {
                    mainId = form.find('input[name="product_id"]').val();
                }

                if (typeof wc_add_to_cart_params === 'undefined') return false;

                $.ajax({
                    type: 'POST',
                    url: wc_add_to_cart_params.wc_ajax_url
                        .toString()
                        .replace('%%endpoint%%', 'irantheme_ajax_add_to_cart'),
                    data: {
                        product_id: mainId,
                        form_data: fData,
                    },
                    beforeSend: (response) => {
                        addToCardBtn.addClass('active');
                        sidebarBtn.addClass('active');
                    },
                    success: function (response) {
                        $(document.body).trigger('wc_fragment_refresh');
                        current.navigationCart.fetchCount();
                        current.tip.createTip(
                            'success',
                            'با موفقیت به سبد خرید اضافه شد',
                            5000,
                            `<br><a href="${iranthemeWoo.shoppingCartUrl}">"مشاهده سبد خرید"</a>`,
                        );
                        form.unblock();
                    },
                    complete: function (response) {
                        addToCardBtn.removeClass('active');
                        sidebarBtn.removeClass('active');
                    },
                    error: function (error) {
                        addToCardBtn.removeClass('active');
                        sidebarBtn.removeClass('active');
                        form.unblock();
                        console.log(error.responseText);
                    },
                });
            }
        });
    }

    handleExternalProductRedirect() {
        let current = this;
        $(document).on('submit', 'form.irantheme-external-form', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();

            let mainExternalBtn = $(this).find(
                '.irantheme-single-add-to-cart-button-external',
            );
            let secondExternalBtn = $(this).find(
                '.irantheme-single-add-to-cart-secoundary-button-external',
            );
            let url = $(this).attr('action');
            if (url) {
                current.tip.createTip(
                    'success',
                    'در حال انتقال به صفحه محصول...',
                    2500,
                );
                window.open(url, '_blank', 'noopener,noreferrer');
                secondExternalBtn.removeClass('d-none');
            } else {
                current.tip.createTip('error', 'آدرس محصول خارجی یافت نشد.');
            }
            return false;
        });
    }

    initAddToCardQuantityBtn() {
        // Get input quantity of product
        let inputQuantity = $('.irantheme-single-product-quantity').find(
            '.irantheme-input-text-quantity',
        );
        // Get minus button
        let minusQuantity = $(inputQuantity).siblings(
            '.irantheme-quantity-selector-minus',
        );
        // Get plus button
        let plusQuantity = $(inputQuantity).siblings(
            '.irantheme-quantity-selector-plus',
        );
        // Get maximum quantity available for buy
        let maxQuantity = parseInt(inputQuantity.attr('max'));
        // Get minimum quantity available for buy
        let minQuantity = parseInt(inputQuantity.attr('min'));
        // Get current quantity entered for buy
        let currentQuantity = parseInt(inputQuantity.val());
        // check current quantity smaller than maximum quantity available
        if (!currentQuantity && currentQuantity !== 0) {
            currentQuantity = 0;
            inputQuantity.val(0);
        }
        if (currentQuantity >= maxQuantity) {
            // Disable plus btn
            plusQuantity.prop('disabled', true);
            // Enable minus btn
            minusQuantity.prop('disabled', false);
            // check current quantity greater than minimum quantity available
        }
        if (currentQuantity <= minQuantity) {
            // Disable minus btn
            minusQuantity.prop('disabled', true);
            // Enable plus btn
            plusQuantity.prop('disabled', false);
        }
    }

    addToCardQuantity() {
        // Plus btn clicked
        $(document).on(
            'click',
            '.irantheme-single-product-quantity .irantheme-quantity-selector-plus',
            function (e) {
                e.preventDefault();
                // Get input quantity of product
                let inputQuantity = $(this).siblings(
                    '.irantheme-input-text-quantity',
                );
                // Get minus btn
                let minusQuantity = $(this).siblings(
                    '.irantheme-quantity-selector-minus',
                );
                // Get maximum quantity available for buy
                let maxQuantity = parseInt(inputQuantity.attr('max'));
                // Get current quantity entered for buy
                let currentQuantity = parseInt(inputQuantity.val());
                if (!currentQuantity && currentQuantity !== 0) {
                    currentQuantity = 0;
                }
                // check current quantity smaller than maximum quantity available
                if (!(currentQuantity >= maxQuantity)) {
                    // Increase quantity value
                    inputQuantity.val(currentQuantity + 1);
                    inputQuantity.attr('value', currentQuantity + 1);
                    // Assign new value of input quantity to currentQuantity variable
                    currentQuantity = parseInt(inputQuantity.val());
                    // Enable minus button
                    minusQuantity.prop('disabled', false);
                }
                // check current quantity greater than maximum quantity available
                if (currentQuantity >= maxQuantity) {
                    // Disable plus button
                    $(this).prop('disabled', true);
                }
            },
        );
        // Minus btn clicked
        $(document).on(
            'click',
            '.irantheme-single-product-quantity .irantheme-quantity-selector-minus',
            function (e) {
                e.preventDefault();
                // Get input quantity of product
                let inputQuantity = $(this).siblings(
                    '.irantheme-input-text-quantity',
                );
                // Get plus btn
                let plusQuantity = $(this).siblings(
                    '.irantheme-quantity-selector-plus',
                );
                // Get minimum quantity available for buy
                let minQuantity = parseInt(inputQuantity.attr('min'));
                // Get current quantity entered for buy
                let currentQuantity = parseInt(inputQuantity.val());
                // check current quantity greater than minimum quantity available
                if (!currentQuantity && currentQuantity !== 0) {
                    currentQuantity = 0;
                }
                if (!(currentQuantity <= minQuantity)) {
                    // Decrease quantity value
                    inputQuantity.val(currentQuantity - 1);
                    inputQuantity.attr('value', currentQuantity - 1);
                    // Assign new value of input quantity to currentQuantity variable
                    currentQuantity = parseInt(inputQuantity.val());
                    // Enable plus button
                    plusQuantity.prop('disabled', false);
                }
                // check current quantity smaller than minimum quantity available
                if (currentQuantity <= minQuantity) {
                    // Disable minus button
                    $(this).prop('disabled', true);
                }
            },
        );
    }

    switchCustomVariationDefaultValueInit() {
        // Get select element
        let select = $('.irantheme-variation-value').find(
            '.irantheme-variation-select',
        );
        // Get options of select
        let options = select.children('option');
        // Get all custom switch
        let allSwitchVar = $(select)
            .siblings('.irantheme-variation-custom-switch')
            .find('.irantheme-custom-switch-var');
        options.each(function (index, element) {
            if ($(element).attr('selected') == 'selected') {
                let option = $(element);
                allSwitchVar.each(function (index, element) {
                    if (
                        $(element).attr('data-switch-value') ==
                        option.attr('value')
                    ) {
                        $(element).addClass('active');
                        if (
                            $(element).hasClass(
                                'irantheme-switch-color-image-var',
                            ) ||
                            $(element).hasClass('irantheme-switch-color-var')
                        ) {
                            let colorLabel = $(element)
                                .parents('.irantheme-variation-value')
                                .siblings('.irantheme-variation-label')
                                .find(
                                    '.irantheme-variation-label-switch-selected',
                                );
                            if (colorLabel.length) {
                                colorLabel.text(
                                    $(element).attr('data-switch-title'),
                                );
                            }
                        }
                    }
                });
            }
        });
    }

    switchCustomVariationClickable() {
        let current = this;
        $(document).on(
            'click',
            '.irantheme-variation-value.irantheme-variation-custom-value .irantheme-custom-switch-var',
            function (e) {
                // Get select element
                let select = $(this)
                    .parents('.irantheme-variation-value')
                    .find('.irantheme-variation-select');
                // Get data attribute of select input
                let dataAttribute = select.attr('data-attribute_name');
                // Get options of select
                let option = select.children('option');
                // Get selected variation switch
                let selectedVar = $(this);
                let allSwitchVar = $(this)
                    .parents('.irantheme-variation-value')
                    .find('.irantheme-custom-switch-var');
                // Remove active class from all switch variation element
                if (!selectedVar.hasClass('disable')) {
                    allSwitchVar.removeClass('active');
                    // Add active class to switch variation selected
                    selectedVar.addClass('active');
                    option.each(function (index, elem) {
                        if (
                            selectedVar.attr('data-switch-value') ==
                            $(elem).attr('value')
                        ) {
                            $(elem).prop('selected', true);
                            // Call woocommerce change trigger
                            $(select).trigger('change');
                            current.variationAssociatedImage(
                                dataAttribute,
                                $(elem).attr('value'),
                            );
                        }
                    });
                }
            },
        );
        // Click on clear btn
        $(document).on(
            'click',
            '.irantheme-variation-value .irantheme-reset-variation',
            function (e) {
                let switchActive = $(this)
                    .parents('.irantheme-variations')
                    .find('.irantheme-variation-custom-switch')
                    .children('.active');
                switchActive.removeClass('active');

                // Restore the original product image.
                current.variationAssociatedImage();

                // Get default thumbnail of hero slider
                let heroSlider = $(
                    '.irantheme-product-gallery-images-hero',
                ).find('.wc-thumbnail-image');

                // Get default thumbnail of thumb slider
                let thumbSlider = $(
                    '.irantheme-product-gallery-images-thumb-slider',
                ).find('.wc-thumbnail-image');

                // Get magnification slider first item
                let magnificationHero = $(
                    '#irantheme_magnification_swiper_product',
                )
                    .find('.irantheme-gallery-magnification-slider-figure')
                    .find(
                        '.irantheme-gallery-magnification-slider-figure-item:first-child',
                    );
                let magnificationThumb = $(
                    '#irantheme_magnification_swiper_product',
                )
                    .find('.irantheme-gallery-magnification-slider-thumb')
                    .find(
                        '.irantheme-gallery-magnification-slider-thumb-item:first-child',
                    );
                // Change image source
                $(heroSlider)
                    .find('.irantheme-zoomImg-magnify')
                    .css({
                        'background-image':
                            'url(' + heroSlider.attr('data-src') + ')',
                    });
                heroSlider.find('img').attr('src', heroSlider.attr('data-src'));
                heroSlider
                    .find('img')
                    .attr('srcset', heroSlider.attr('data-srcset'));
                heroSlider
                    .find('img')
                    .attr('sizes', heroSlider.attr('data-sizes'));
                if (thumbSlider.length) {
                    thumbSlider
                        .find('img')
                        .attr('src', heroSlider.attr('data-src'));
                    thumbSlider
                        .find('img')
                        .attr('srcset', heroSlider.attr('data-srcset'));
                    thumbSlider
                        .find('img')
                        .attr('sizes', heroSlider.attr('data-sizes'));
                }
                magnificationHero
                    .find('img')
                    .attr('src', heroSlider.attr('data-src'));
                magnificationThumb
                    .find('img')
                    .attr('src', heroSlider.attr('data-src'));

                let colorLabel = $('.irantheme-variation-label').find(
                    '.irantheme-variation-label-switch-selected',
                );
                if (colorLabel.length) {
                    colorLabel.text(colorLabel.data('empty-text'));
                }
            },
        );
        // Click on default variation
        $(document).on(
            'click',
            '.irantheme-variation-value:not(.irantheme-variation-custom-value)',
            function (e) {
                // Get select element
                let select = $(this).find('.irantheme-variation-select');

                // Get data attribute of select input
                let dataAttribute = select.attr('data-attribute_name');

                // Get the currently selected value
                let selectedValue = select.val();

                // Update variation image once using the current selection
                current.variationAssociatedImage(dataAttribute, selectedValue);
            },
        );
    }

    colorSwitchVariationLabel() {
        $(document).on(
            'click',
            '.irantheme-variation-value.irantheme-variation-custom-value .irantheme-switch-color-image-var, .irantheme-variation-value.irantheme-variation-custom-value .irantheme-switch-color-var',
            function (e) {
                let colorSelected = $(this);
                if (colorSelected.hasClass('disable')) {
                    return;
                }
                let label = $(this)
                    .parents('.irantheme-variation-value')
                    .siblings('.irantheme-variation-label')
                    .find('.irantheme-variation-label-switch-selected');
                if (label.length) {
                    label.text(colorSelected.attr('data-switch-title'));
                }
            },
        );
    }

    switchCustomDisabler() {
        // Loop through each WooCommerce variation select.
        $('.irantheme-variation-select').each(function () {
            const select = $(this)[0];

            // Skip if the select element does not exist.
            if (!select) {
                return;
            }

            // Update custom switch states based on the available select options.
            const updateSwitches = () => {
                const $select = $(select);
                const attributeName = $select.attr('name');

                // Skip if the select has no attribute name.
                if (!attributeName) {
                    return;
                }

                // Collect the values of all available, enabled options.
                const availableValues = new Set(
                    Array.from(select.options)
                        .filter((option) => {
                            return option.value !== '' && !option.disabled;
                        })
                        .map((option) => option.value),
                );

                // Find custom switches associated with the current select.
                const $switches = $(
                    '.irantheme-variation-value.irantheme-variation-custom-value ' +
                        '.irantheme-custom-switch-var',
                ).filter(function () {
                    return $(this)
                        .closest('.irantheme-variation-value')
                        .find('.irantheme-variation-select')
                        .is(select);
                });

                // Disable switches whose values are not available in the select.
                $switches.each(function () {
                    const $switch = $(this);
                    const value = String($switch.attr('data-switch-value'));

                    $switch.toggleClass('disable', !availableValues.has(value));
                });
            };

            // Synchronize switch states immediately.
            updateSwitches();

            // Observe option changes and disabled attribute updates in the select.
            const observer = new MutationObserver(updateSwitches);

            observer.observe(select, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ['disabled'],
            });

            // Recheck switch states whenever the select value changes.
            $(select).on('change.iranthemeCustomSwitch', updateSwitches);
        });
    }

    woocommerceTabPanelInit() {
        $(document).on('ready', function (e) {
            // Get active tabs
            let activeTabs = $('.irantheme-single-product-content-tabs').find(
                '.irantheme-single-product-content-tabs-list-item.active',
            );
            if (activeTabs.length) {
                // Get color class from active tab
                let dataClassValue = $(activeTabs).attr('data-active-class');

                // Add color class to active tab
                activeTabs
                    .find(
                        '.irantheme-single-product-content-tabs-list-item-anchor',
                    )
                    .addClass(dataClassValue);

                // Add color class to count of review tabs
                activeTabs.find('.review-count').addClass(dataClassValue);
            }
        });

        $('.irantheme-single-product-content-tabs-list').on(
            'click',
            '.irantheme-single-product-content-tabs-list-item',
            function (e) {
                // Get selected tab
                let selectedTab = $(this);
                // Get data rel of tab
                let selectedTabRel = selectedTab.attr('data-rel');
                // Get all tabs
                let allTabs = $(this)
                    .parents('.irantheme-single-product-content-tabs-list')
                    .find('.irantheme-single-product-content-tabs-list-item');
                // Get all tab panel
                let allTabPanel = $(
                    '.irantheme-single-product-content-tabs-panel',
                );
                // Get color class from selected tab
                let dataClassValue = $(this).attr('data-active-class');

                // Add active class to selected tab
                if (!selectedTab.hasClass('active')) {
                    // Remove active class from all tabs
                    allTabs.removeClass('active');
                    // Add active active class to active tab
                    selectedTab.addClass('active');
                    // Hide all tab panel
                    allTabPanel.css('display', 'none');
                    // Show selected tab panel
                    $('#' + selectedTabRel).css('display', 'block');

                    if (
                        $(window).scrollTop() + 500 <
                        $('#' + selectedTabRel).offset().top
                    ) {
                        // Scroll to top of tab panel
                        $('html, body').animate(
                            {
                                scrollTop:
                                    $('#' + selectedTabRel).offset().top - 100,
                            },
                            2000,
                        );
                    }
                }

                // Remove color class from all tabs
                allTabs
                    .find(
                        '.irantheme-single-product-content-tabs-list-item-anchor',
                    )
                    .removeClass(dataClassValue);

                // Add color class to selected tab
                selectedTab
                    .find(
                        '.irantheme-single-product-content-tabs-list-item-anchor',
                    )
                    .addClass(dataClassValue);

                // Add color class to count of review tabs
                selectedTab.find('.review-count').addClass(dataClassValue);
            },
        );
    }

    colorBreadcrumbInit() {
        let breadCrumb = $('.irantheme-woocommerce-breadcrumb');
        let dataClassColor = breadCrumb.attr('data-hover-class');
        breadCrumb.find('a').addClass(dataClassColor);
    }

    InitProductShareModal() {
        let current = this;
        let shareModalWrapper = $('.product-share-tools-modal');
        if (shareModalWrapper.length) {
            $(document).on(
                'click',
                '#irantheme_product_share_tools_toggler,#irantheme_product_share_tools_toggler_mobile',
                function (e) {
                    shareModalWrapper.fadeIn(250);
                },
            );
            $(document).on(
                'click',
                '.irantheme-popup-modal .close',
                function (e) {
                    $(this).parents('.irantheme-popup-modal').fadeOut(250);
                },
            );
            $(document).on(
                'click',
                '.share-content-product-link-copy .irantheme-product-share-link',
                function (e) {
                    let productPermalink = $(this)
                        .find('a')
                        .attr('data-product-permalink');
                    var $temp = $('<input>');
                    $('body').append($temp);
                    $temp.val(productPermalink).trigger('select');
                    document.execCommand('copy');
                    $temp.remove();
                    current.tip.createTip('success', 'لینک کپی شد.');
                },
            );
        }
    }

    variationAssociatedImage() {
        // Get the product variation form.
        const $form = $('.irantheme-variations-form').first();

        if (!$form.length) {
            return;
        }

        // Get the variation data from the form.
        const formData = $form.attr('data-product_variations');

        if (!formData) {
            return;
        }

        let variations;

        // Parse the variation data safely.
        try {
            variations = JSON.parse(formData);
        } catch (error) {
            console.error('Failed to parse product variation data:', error);
            return;
        }

        // Make sure the variation data is an array.
        if (!Array.isArray(variations)) {
            return;
        }

        // Get the gallery elements.
        const $heroSlider = $(
            '.product-image-hero-wrapper .wc-thumbnail-image',
        ).first();

        const $thumbSlider = $(
            '.product-image-thumb-slider-wrapper .wc-thumbnail-image',
        ).first();

        const $magnification = $('#irantheme_magnification_swiper_product');

        const $magnificationHero = $magnification
            .find('.irantheme-gallery-magnification-slider-figure')
            .find(
                '.irantheme-gallery-magnification-slider-figure-item:first-child',
            );

        const $magnificationThumb = $magnification
            .find('.irantheme-gallery-magnification-slider-thumb')
            .find(
                '.irantheme-gallery-magnification-slider-thumb-item:first-child',
            );

        // Collect all variation attribute selects.
        const $selects = $form.find('select[name^="attribute_"]');

        if (!$selects.length) {
            return;
        }

        // Save the original gallery image only once.
        // This must happen before this method changes the image.
        if (!$heroSlider.data('irantheme-original-image-saved')) {
            const saveImages = ($container) => {
                $container.find('img').each(function () {
                    const $img = $(this);

                    $img.data('irantheme-original-src', $img.attr('src'));
                    $img.data('irantheme-original-srcset', $img.attr('srcset'));
                    $img.data('irantheme-original-sizes', $img.attr('sizes'));
                });
            };

            saveImages($heroSlider);
            saveImages($thumbSlider);
            saveImages($magnificationHero);
            saveImages($magnificationThumb);

            // Save the original zoom background.
            $heroSlider.find('.irantheme-zoomImg-magnify').each(function () {
                $(this).data(
                    'irantheme-original-background',
                    $(this).css('background-image'),
                );
            });

            $heroSlider.data('irantheme-original-image-saved', true);
        }

        // Restore the original gallery image.
        const restoreOriginalImages = () => {
            const restoreImages = ($container) => {
                $container.find('img').each(function () {
                    const $img = $(this);
                    const originalSrc = $img.data('irantheme-original-src');
                    const originalSrcset = $img.data(
                        'irantheme-original-srcset',
                    );
                    const originalSizes = $img.data('irantheme-original-sizes');

                    if (originalSrc !== undefined) {
                        $img.attr('src', originalSrc);
                    }

                    if (originalSrcset !== undefined) {
                        $img.attr('srcset', originalSrcset);
                    }

                    if (originalSizes !== undefined) {
                        $img.attr('sizes', originalSizes);
                    }
                });
            };

            restoreImages($heroSlider);
            restoreImages($thumbSlider);
            restoreImages($magnificationHero);
            restoreImages($magnificationThumb);

            // Restore the original zoom background.
            $heroSlider.find('.irantheme-zoomImg-magnify').each(function () {
                const originalBackground = $(this).data(
                    'irantheme-original-background',
                );

                if (originalBackground !== undefined) {
                    $(this).css('background-image', originalBackground);
                }
            });
        };

        // Read the currently selected attribute values.
        const selectedAttributes = {};

        $selects.each(function () {
            selectedAttributes[this.name] = $(this).val() || '';
        });

        // Check whether all attributes have been reset.
        const isReset = Object.values(selectedAttributes).every(
            (value) => value === '',
        );

        // Restore the original image when all attributes are reset.
        if (isReset) {
            restoreOriginalImages();
            return;
        }

        // Do not change the image until every required attribute is selected.
        const allAttributesSelected = Object.values(selectedAttributes).every(
            (value) => value !== '',
        );

        if (!allAttributesSelected) {
            return;
        }

        // Find a variation matching all selected attributes.
        // Empty variation attributes represent "Any" and can match
        // a selected value, but the first compatible variation is not
        // necessarily the exact intended variation when several match.
        const matchedVariation = variations.find((variation) => {
            const attributes = variation.attributes || {};

            return Object.keys(selectedAttributes).every((attributeName) => {
                const selectedValue = selectedAttributes[attributeName];
                const variationValue = attributes[attributeName];

                // Ignore attributes that are not present in the variation data.
                if (variationValue === undefined || variationValue === '') {
                    return true;
                }

                return variationValue === selectedValue;
            });
        });

        // Leave the current image unchanged if no matching variation exists.
        if (!matchedVariation || !matchedVariation.image) {
            return;
        }

        // Get the selected variation image.
        const imgSrc = matchedVariation.image.full_src;
        const imgSrcset = matchedVariation.image.srcset || '';

        if (!imgSrc) {
            return;
        }

        // Update the main product image.
        if ($heroSlider.length) {
            $heroSlider.find('img').attr({
                src: imgSrc,
                srcset: imgSrcset,
            });

            // Update the zoom background.
            $heroSlider
                .find('.irantheme-zoomImg-magnify')
                .css('background-image', `url("${imgSrc}")`);
        }

        // Update the product thumbnail image.
        if ($thumbSlider.length) {
            $thumbSlider.find('img').attr({
                src: imgSrc,
                srcset: imgSrcset,
            });
        }

        // Update the magnification gallery image.
        if ($magnificationHero.length) {
            $magnificationHero.find('img').attr({
                src: imgSrc,
                srcset: imgSrcset,
            });
        }

        // Update the magnification gallery thumbnail.
        if ($magnificationThumb.length) {
            $magnificationThumb.find('img').attr({
                src: imgSrc,
                srcset: imgSrcset,
            });
        }
    }

    initShoppingSummaryProductDetails() {
        // Wait for the document to be fully loaded
        $(document).on('ready', function () {
            // Get variation data from variation form
            let variationsForm = $('.variations_form');

            if (variationsForm.length) {
                // Get price holder
                let targetPriceContainer = $('.product-add-to-card-price');

                // Get default price
                let defaultPriceHtml = targetPriceContainer
                    .find('.price')
                    .first()
                    .html();

                // Get product selected features holder
                let selectedOptionsContainer = $(
                    '.product-selected-features-list',
                );

                // Get stock holder
                let targetStockContainer = $(
                    '.product-add-to-card-stock-status',
                );

                // Get quantity input field
                let qtyInput = $('input[name="quantity"]');

                // Function for price update
                function updatePrice(priceHtml, isDefaultPrice = false) {
                    targetPriceContainer.each(
                        function (pContainerIndex, pContainerElement) {
                            let priceElement = $(pContainerElement)
                                .find('.price')
                                .first();
                            if (priceElement.length) {
                                // Determine label text based on context
                                let labelText = isDefaultPrice
                                    ? 'شروع قیمت از: '
                                    : 'قیمت: ';

                                // Check if priceHtml already contains a label
                                if (priceHtml.includes('price-label')) {
                                    // If it already has a label, just update the content
                                    priceElement.html(priceHtml);
                                } else {
                                    // If no label in priceHtml, add the appropriate label
                                    priceElement.html(
                                        '<span class="price-label">' +
                                            labelText +
                                            '</span>' +
                                            priceHtml,
                                    );
                                }
                            } else if (priceHtml) {
                                // If the price tag is not there, add it correctly with its classes.
                                let labelText = isDefaultPrice
                                    ? 'شروع قیمت از: '
                                    : 'قیمت: ';
                                pContainerElement.prepend(
                                    '<p class="price irantheme-woocommerce-product-price not-product-variable">' +
                                        '<span class="price-label">' +
                                        labelText +
                                        '</span>' +
                                        priceHtml +
                                        '</p>',
                                );
                            }
                        },
                    );
                }

                // Function to update the stock status
                function updateStockStatus(variation) {
                    // Delete previous content
                    targetStockContainer.empty();

                    const lowStockThreshold = 5;
                    let stockStatusHtml = '';

                    if (variation && variation.is_in_stock) {
                        const stockQuantity = variation.max_qty;

                        // If the inventory is low
                        if (
                            !variation.backorders_allowed &&
                            stockQuantity <= lowStockThreshold &&
                            stockQuantity > 0
                        ) {
                            stockStatusHtml = `<p class="product-add-to-card-stock-status-item low-stock">فقط ${stockQuantity} عدد در انبار باقی مانده!</p>`;
                        } else if (variation.backorders_allowed) {
                            // If the product can be reordered
                            stockStatusHtml = `<p class="product-add-to-card-stock-status-item backorder">موجود در انبار: قابل پیش خرید</p>`;
                        } else if (stockQuantity == '') {
                            // If the product can be reordered
                            stockStatusHtml = `<p class="product-add-to-card-stock-status-item in-stock">موجود در انبار</p>`;
                        } else {
                            // If there is a lot of inventory
                            stockStatusHtml = `<p class="product-add-to-card-stock-status-item in-stock">موجود در انبار: ${stockQuantity} عدد</p>`;
                        }
                    } else if (variation) {
                        // If not available
                        stockStatusHtml = `<p class="product-add-to-card-stock-status-item out-of-stock">ناموجود</p>`;
                    }

                    targetStockContainer.html(stockStatusHtml);
                }

                function updateQuantityInput(variation) {
                    if (qtyInput.length) {
                        if (
                            variation.is_in_stock &&
                            variation.max_qty !== undefined
                        ) {
                            qtyInput.attr('max', variation.max_qty);
                            qtyInput.val(1);
                        } else {
                            // If it is not present, set max to a large number or empty.
                            qtyInput.attr('max', '');
                            qtyInput.val(1);
                        }
                    }
                }

                // Function for selected features list update
                function updateSelectedOptions() {
                    $('.product-selected-features-list-item').each(function () {
                        let attributeName = $(this).data('attribute-name');
                        let selectedValue = $(
                            `[name="attribute_${attributeName}"]`,
                        ).val();
                        let selectedText = $(
                            `[name="attribute_${attributeName}"] option:selected`,
                        ).text();
                        if (attributeName) {
                            if (selectedValue) {
                                $(this)
                                    .find(
                                        '.product-selected-features-list-item-value',
                                    )
                                    .text(selectedText);
                            } else {
                                $(this)
                                    .find(
                                        '.product-selected-features-list-item-value',
                                    )
                                    .text('انتخاب نشده');
                            }
                        }
                    });
                }

                // Get all variation data to be used for manual lookup
                const allVariationsData =
                    variationsForm.data('product_variations');

                // New Logic: Check for a valid variation on every change event
                variationsForm.on('change', 'select', function () {
                    let selectedAttributes = {};
                    let allAttributesSelected = true;

                    variationsForm.find('select').each(function () {
                        let name = $(this).attr('name');
                        let value = $(this).val();

                        if (value) {
                            selectedAttributes[name] = value;
                        } else {
                            allAttributesSelected = false;
                        }
                    });

                    if (allAttributesSelected) {
                        let selectedVariation = null;

                        if (allVariationsData && allVariationsData.length > 0) {
                            selectedVariation = allVariationsData.find((v) => {
                                let match = true;
                                for (let attr in selectedAttributes) {
                                    if (
                                        selectedAttributes[attr] !==
                                        v.attributes[attr]
                                    ) {
                                        match = false;
                                        break;
                                    }
                                }
                                return match;
                            });
                        }

                        if (selectedVariation) {
                            updatePrice(selectedVariation.price_html, false);
                            updateSelectedOptions();
                            updateStockStatus(selectedVariation);
                            updateQuantityInput(selectedVariation);
                        } else {
                            updatePrice(defaultPriceHtml, true);
                            selectedOptionsContainer
                                .find(
                                    '.product-selected-features-list-item:not(.no-change)',
                                )
                                .find(
                                    '.product-selected-features-list-item-value',
                                )
                                .text('انتخاب نشده');
                            targetStockContainer.empty();
                            qtyInput.attr('max', '');
                            qtyInput.val(1);
                        }
                    } else {
                        updatePrice(defaultPriceHtml, true);
                        selectedOptionsContainer
                            .find(
                                '.product-selected-features-list-item:not(.no-change)',
                            )
                            .find('.product-selected-features-list-item-value')
                            .text('انتخاب نشده');
                        targetStockContainer.empty();
                        qtyInput.attr('max', '');
                        qtyInput.val(1);
                    }
                });

                // Listening to event change events
                variationsForm.on(
                    'found_variation',
                    function (event, variation) {
                        // We check if price_html exists.
                        if (variation.price_html) {
                            updatePrice(variation.price_html, false);
                        } else {
                            // If price_html does not exist, we will use the default product price.
                            updatePrice(defaultPriceHtml, true);
                        }
                        updateSelectedOptions();
                        updateStockStatus(variation);
                        updateQuantityInput(variation);
                    },
                );

                // Listen to event clear options
                variationsForm.on('reset_image', function () {
                    updatePrice(defaultPriceHtml, true);
                    selectedOptionsContainer
                        .find(
                            '.product-selected-features-list-item:not(.no-change)',
                        )
                        .find('.product-selected-features-list-item-value')
                        .text('انتخاب نشده');
                    targetStockContainer.empty();
                    qtyInput.attr('max', '');
                    qtyInput.val(1);
                });

                // Show the default price when loading
                updatePrice(defaultPriceHtml, true);
            }
        });
    }

    syncSidebarAndMainButtons() {
        let current = this;

        // Get add to card btn from shopping summary column
        let $sidebarAddToCartBtn = $(
            '.irantheme-single-product-shopping-summary .product-add-to-card-button button.single_add_to_cart_button',
        );

        let $mainQuantityInput = $('form.cart .quantity .qty');

        // Sync Add to Cart button click
        $sidebarAddToCartBtn
            .off('click.sync')
            .on('click.sync', function (event) {
                // If the button is external, do nothing.
                if (
                    $(this).hasClass(
                        'irantheme-single-add-to-cart-button-external',
                    )
                ) {
                    return;
                }

                event.preventDefault();

                // Get quantity input from shopping summary column
                let $sidebarQuantityInput = $(this)
                    .parents('.irantheme-single-product-shopping-summary')
                    .find('.quantity .qty');

                let quantity = $sidebarQuantityInput.val();
                $mainQuantityInput.val(quantity);
                $(
                    '.irantheme-single-product-shopping-summary .quantity .qty',
                ).val(quantity);
                // Simulate clicking the main button
                $('form.cart button.single_add_to_cart_button').trigger(
                    'click',
                );
            });
    }
    syncNavbarMobileAndMainButtons() {
        let current = this;

        // Get add to card btn from shopping summary column
        let $sidebarAddToCartBtn = $(
            '.irantheme-single-product-navbar-mobile .product-add-to-card-button button.single_add_to_cart_button',
        );

        let $mainQuantityInput = $('form.cart .quantity .qty');

        // Sync Add to Cart button click
        $sidebarAddToCartBtn
            .off('click.sync')
            .on('click.sync', function (event) {
                // If the button is external, do nothing.
                if (
                    $(this).hasClass(
                        'irantheme-single-add-to-cart-button-external',
                    )
                ) {
                    return;
                }
                event.preventDefault();

                // Get quantity input from shopping summary column
                let $sidebarQuantityInput = $(this)
                    .parents('.irantheme-single-product-navbar-mobile')
                    .find('.quantity .qty');

                let quantity = $sidebarQuantityInput.val();
                $mainQuantityInput.val(quantity);
                $('.irantheme-single-product-navbar-mobile .quantity .qty').val(
                    quantity,
                );
                // Simulate clicking the main button
                $('form.cart button.single_add_to_cart_button').trigger(
                    'click',
                );
            });
    }

    syncAllQuantityBtn() {
        $(document).on(
            'click',
            '.irantheme-single-product-quantity .irantheme-quantity-selector-plus',
            function (e) {
                let quantity = $(this).siblings('.qty').val();
                $(
                    '.irantheme-single-product-shopping-summary,.irantheme-single-product-navbar-mobile',
                )
                    .find('.quantity .qty')
                    .val(quantity);
                if (
                    $(this)
                        .parents(
                            '.irantheme-single-product-shopping-summary,.irantheme-single-product-navbar-mobile',
                        )
                        .find('.irantheme-quantity-selector-minus')
                        .is(':disabled')
                ) {
                    $(
                        '.irantheme-single-product-shopping-summary .irantheme-quantity-selector-minus',
                    ).prop('disabled', true);
                    $(
                        '.irantheme-single-product-navbar-mobile .irantheme-quantity-selector-minus',
                    ).prop('disabled', true);
                } else {
                    $(
                        '.irantheme-single-product-shopping-summary .irantheme-quantity-selector-minus',
                    ).prop('disabled', false);
                    $(
                        '.irantheme-single-product-navbar-mobile .irantheme-quantity-selector-minus',
                    ).prop('disabled', false);
                }
                if (
                    $(this)
                        .parents(
                            '.irantheme-single-product-shopping-summary,.irantheme-single-product-navbar-mobile',
                        )
                        .find('.irantheme-quantity-selector-plus')
                        .is(':disabled')
                ) {
                    $(
                        '.irantheme-single-product-shopping-summary .irantheme-quantity-selector-plus',
                    ).prop('disabled', true);
                    $(
                        '.irantheme-single-product-navbar-mobile .irantheme-quantity-selector-plus',
                    ).prop('disabled', true);
                } else {
                    $(
                        '.irantheme-single-product-shopping-summary .irantheme-quantity-selector-plus',
                    ).prop('disabled', false);
                    $(
                        '.irantheme-single-product-navbar-mobile .irantheme-quantity-selector-plus',
                    ).prop('disabled', false);
                }
            },
        );
        $(document).on(
            'click',
            '.irantheme-single-product-quantity .irantheme-quantity-selector-minus',
            function (e) {
                let quantity = $(this).siblings('.qty').val();
                $(
                    '.irantheme-single-product-shopping-summary,.irantheme-single-product-navbar-mobile',
                )
                    .find('.quantity .qty')
                    .val(quantity);
                if (
                    $(this)
                        .parents(
                            '.irantheme-single-product-shopping-summary,.irantheme-single-product-navbar-mobile',
                        )
                        .find('.irantheme-quantity-selector-minus')
                        .is(':disabled')
                ) {
                    $(
                        '.irantheme-single-product-shopping-summary .irantheme-quantity-selector-minus',
                    ).prop('disabled', true);
                    $(
                        '.irantheme-single-product-navbar-mobile .irantheme-quantity-selector-minus',
                    ).prop('disabled', true);
                } else {
                    $(
                        '.irantheme-single-product-shopping-summary .irantheme-quantity-selector-minus',
                    ).prop('disabled', false);
                    $(
                        '.irantheme-single-product-navbar-mobiley .irantheme-quantity-selector-minus',
                    ).prop('disabled', false);
                }
                if (
                    $(this)
                        .parents(
                            '.irantheme-single-product-shopping-summary,.irantheme-single-product-navbar-mobile',
                        )
                        .find('.irantheme-quantity-selector-plus')
                        .is(':disabled')
                ) {
                    $(
                        '.irantheme-single-product-shopping-summary .irantheme-quantity-selector-plus',
                    ).prop('disabled', true);
                    $(
                        '.irantheme-single-product-navbar-mobile .irantheme-quantity-selector-plus',
                    ).prop('disabled', true);
                } else {
                    $(
                        '.irantheme-single-product-shopping-summary .irantheme-quantity-selector-plus',
                    ).prop('disabled', false);
                    $(
                        '.irantheme-single-product-navbar-mobile .irantheme-quantity-selector-plus',
                    ).prop('disabled', false);
                }
            },
        );
    }

    initProductQuestionReplyModal() {
        // Open popup modal
        $('.open-reply-modal-btn').on('click', function () {
            var qaId = $(this).data('qa-id');
            var productId = $(this).data('product-id');
            // Places the question ID in a hidden field in the popup form
            $('#reply-qa-id').val(qaId);
            $('#reply_qa_product_id').val(productId);
            // Places the question text in a in the popup
            $('.qa-content-question-holder').html(
                '<p class="qa-content-question-holder-text">' +
                    $(this).attr('data-question') +
                    '</p>',
            );

            // Show popup
            $('#irantheme_qa_reply_modal').fadeIn(250);
        });

        $(document).on('click', '.irantheme-popup-modal .close', function (e) {
            $(this).parents('.irantheme-popup-modal').fadeOut(250);
        });

        // Close popup window when clicking outside modal
        $(window).on('click', function (event) {
            if ($(event.target).is('.product-qa-reply-modal')) {
                $(event.target).fadeOut(250);
            }
        });
    }

    initProductQuestionSubmissionModal() {
        // // Open popup modal
        $('.open-question-modal-btn').on('click', function () {
            var qaId = $(this).data('product-id');

            // Places the question ID in a hidden field in the popup form
            $('#question_product_id').val(qaId);

            // Show popup
            $('#irantheme_qa_question_modal').fadeIn(250);
        });

        $(document).on('click', '.irantheme-popup-modal .close', function (e) {
            $(this).parents('.irantheme-popup-modal').fadeOut(250);
        });

        // Close popup window when clicking outside modal
        $(window).on('click', function (event) {
            if ($(event.target).is('.product-qa-question-modal')) {
                $(event.target).fadeOut(250);
            }
        });
    }

    initProductAddCommentModal() {
        // Open popup modal
        $('.open-add-comment-modal-btn').on('click', function () {
            $('#irantheme_add_comment_modal').fadeIn(250);
        });

        $(document).on('click', '.irantheme-popup-modal .close', function (e) {
            $(this).parents('.irantheme-popup-modal').fadeOut(250);
        });

        // Close popup window when clicking outside modal
        $(window).on('click', function (event) {
            if ($(event.target).is('.product-add-comment-modal')) {
                $(event.target).fadeOut(250);
            }
        });
    }

    initDownloadableFileDetails() {
        $(document).on('ready', function () {
            if ($('.irantheme-downloadable-product').length) {
                let $variationsForm = $('.variations_form');
                let $infoBox = $('#irantheme_download_info');

                function updateDownloadDetails(variation) {
                    if (!$infoBox.length) return;

                    // If the variation is not selected or not downloadable
                    if (!variation || !variation.is_downloadable) {
                        $infoBox.find('#file_version_number').text('');
                        $infoBox.find('#file_update_date').text('');
                        $infoBox.find('#file_release_date').text('');
                        $infoBox.find('.irantheme-file-details').hide();
                        return;
                    }

                    // Display and update values, if the value is empty, display '---'
                    $infoBox
                        .find('#file_version_number')
                        .text(variation.file_version_number || '---');
                    $infoBox
                        .find('#file_update_date')
                        .text(variation.file_update_date || '---');
                    $infoBox
                        .find('#file_release_date')
                        .text(variation.file_release_date || '---');

                    $infoBox.find('.irantheme-file-details').show();
                }

                // --- 1. User Interaction Management ---

                // When the user selects a variation
                $variationsForm.on(
                    'found_variation',
                    function (event, variation) {
                        updateDownloadDetails(variation);
                    },
                );

                // When clearing the selection
                $variationsForm.on('reset_image', function () {
                    updateDownloadDetails(null); // Sending Null for clearing and hiding
                });

                // --- 2. Managing the initial page load ---

                if ($variationsForm.length) {
                    let initialVariationId = $variationsForm
                        .find('input[name="variation_id"]')
                        .val();
                    let allVariationsData =
                        $variationsForm.data('product_variations');

                    if (initialVariationId && allVariationsData) {
                        // Finding the Default Variation Object
                        let initialVariation = allVariationsData.find(
                            function (v) {
                                return v.variation_id == initialVariationId;
                            },
                        );

                        if (initialVariation) {
                            // Run an update with default variation data
                            updateDownloadDetails(initialVariation);
                        }
                    } else {
                        // If the default variation is not selected, we make sure the box remains hidden.
                        $infoBox.find('.irantheme-file-details').hide();
                    }
                }
            }
        });
    }
    initReviewAndQAQuickView() {
        if ($('.woocommerce-review-link').length) {
            $('.woocommerce-review-link').on('click', function () {
                $('#irantheme_tab_reviews').trigger('click');
            });
        }
        if ($('.woocommerce-question-link').length) {
            $('.woocommerce-question-link').on('click', function () {
                $('#irantheme_tab_product_qa').trigger('click');
            });
        }
        if ($('.woocommerce-additional-information-link').length) {
            $('.woocommerce-additional-information-link').on(
                'click',
                function () {
                    $('#irantheme_tab_additional_information').trigger('click');
                },
            );
        }
    }
}

export default WoocommerceSingleProduct;
